export default "__VITE_ASSET__DFJ7cPeV__"